import { SteeringIcon } from './SteeringIcon';

/**
 * author: Google
 * id A2FE9DC5-BC17-4265-9D2C-4CA20135C4BB
 * name steering
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/steering.svg
 * tags
 * - Automotive 
 */
export const SearchHandsFreeIcon = SteeringIcon;
export default SearchHandsFreeIcon